export enum LinksWithSubMenu {
  TEAMS = "teams",
  COMPETITIONS = "competitions",
}

export const SERVER_ERROR_CODE = 500;
export const OUT_ANIMATION_DURATION = 250 + 650;

export const OFTV_URL = "https://tv.onefootball.com";
export const BETS_PTBR_URL = "https://onefootball.com/pt-br/apostas";

export const BETS_COUNTRY_MAP: Record<string, string> = {
  BR: "pt-br/apostas",
  ES: "es/apuestas",
  PE: "es/apuestas/pe",
  CL: "es/apuestas/cl",
  MX: "es/apuestas/mx",
  CO: "es/apuestas/co",
  UK: "en/betting",
  US: "en/betting/us",
  IN: "en/betting/in",
};
